// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3OV0G","content":"RecentSearches_content__f0LfI"};